import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Grid,
  IconButton,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import sigcodService from '../services/sigcodService';

const DevolucionFormModal = ({ open, onClose, onSubmit }) => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [selectedSolicitud, setSelectedSolicitud] = useState('');
  const [motivo, setMotivo] = useState('');
  const [documentos, setDocumentos] = useState([]);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      sigcodService
        .getRequests({ estado: 'ENTREGADA_AL_CLIENTE', limit: 100 })
        .then((res) => setSolicitudes(res.data || []))
        .catch(() => {});
    }
  }, [open]);

  useEffect(() => {
    if (selectedSolicitud) {
      sigcodService
        .getDocuments(selectedSolicitud)
        .then((res) => {
          setDocumentos(res.data || []);
          setSelectedDocs([]);
        })
        .catch(() => {});
    } else {
      setDocumentos([]);
      setSelectedDocs([]);
    }
  }, [selectedSolicitud]);

  const toggleDoc = (docId) => {
    setSelectedDocs((prev) =>
      prev.includes(docId) ? prev.filter((id) => id !== docId) : [...prev, docId]
    );
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await onSubmit({
        solicitudId: selectedSolicitud,
        motivo,
        documentoIds: selectedDocs,
      });
      setSelectedSolicitud('');
      setMotivo('');
      setSelectedDocs([]);
      onClose();
    } catch {
      // error handled by parent
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600}>Nueva Devolucion</Typography>
          <IconButton onClick={onClose} size="small"><Close /></IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2.5}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Solicitud"
              value={selectedSolicitud}
              onChange={(e) => setSelectedSolicitud(e.target.value)}
            >
              {solicitudes.map((s) => (
                <MenuItem key={s._id} value={s._id}>
                  {s.consecutivo} - {s.tipo} ({s.solicitante?.nombre})
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              required
              label="Motivo de devolucion"
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
            />
          </Grid>
          {documentos.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
                Documentos a devolver
              </Typography>
              {documentos.map((doc) => (
                <FormControlLabel
                  key={doc._id}
                  control={
                    <Checkbox
                      checked={selectedDocs.includes(doc._id)}
                      onChange={() => toggleDoc(doc._id)}
                      size="small"
                    />
                  }
                  label={
                    <Typography variant="body2">
                      {doc.nombre} {doc.caja ? `(Caja: ${doc.caja})` : ''}
                    </Typography>
                  }
                />
              ))}
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!selectedSolicitud || !motivo.trim() || submitting}
        >
          Crear Devolucion
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DevolucionFormModal;
